import evenementAdapter from "services/office365/dto/Calendrier/shared/EvenementAdapter";

export default function calendrierObtenirLesEvenementsAdapter(response = []) {
  return response.map((item) => evenementAdapter(item));
}
